import _extends from "@babel/runtime-corejs3/helpers/extends";(function () {var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;enterModule && enterModule(module);})();function _EMOTION_STRINGIFIED_CSS_ERROR__() {return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";}var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {return a;}; /**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { useCallback, useMemo } from 'react';





import { extent as d3Extent, max as d3Max } from 'd3-array';
import { FaSort } from '@react-icons/all-files/fa/FaSort';
import { FaSortDown as FaSortDesc } from '@react-icons/all-files/fa/FaSortDown';
import { FaSortUp as FaSortAsc } from '@react-icons/all-files/fa/FaSortUp';
import {


DTTM_ALIAS,
ensureIsArray,
GenericDataType,
getTimeFormatterForGranularity,
t,
tn } from
'@superset-ui/core';


import DataTable from




'./DataTable';

import Styles from './Styles';
import { formatColumnValue } from './utils/formatValue';
import { PAGE_SIZE_OPTIONS } from './consts';
import { updateExternalFormData } from './DataTable/utils/externalAPIs';import { jsx as ___EmotionJSX } from "@emotion/react";



/**
 * Return sortType based on data type
 */
function getSortTypeByDataType(dataType) {
  if (dataType === GenericDataType.TEMPORAL) {
    return 'datetime';
  }
  if (dataType === GenericDataType.STRING) {
    return 'alphanumeric';
  }
  return 'basic';
}

/**
 * Cell background to render columns as horizontal bar chart
 */
function cellBar({
  value,
  valueRange,
  colorPositiveNegative = false,
  alignPositiveNegative })





{
  const [minValue, maxValue] = valueRange;
  const r = colorPositiveNegative && value < 0 ? 150 : 0;
  if (alignPositiveNegative) {
    const perc = Math.abs(Math.round(value / maxValue * 100));
    // The 0.01 to 0.001 is a workaround for what appears to be a
    // CSS rendering bug on flat, transparent colors
    return (
      `linear-gradient(to right, rgba(${r},0,0,0.2), rgba(${r},0,0,0.2) ${perc}%, ` +
      `rgba(0,0,0,0.01) ${perc}%, rgba(0,0,0,0.001) 100%)`);

  }
  const posExtent = Math.abs(Math.max(maxValue, 0));
  const negExtent = Math.abs(Math.min(minValue, 0));
  const tot = posExtent + negExtent;
  const perc1 = Math.round(
  Math.min(negExtent + value, negExtent) / tot * 100);

  const perc2 = Math.round(Math.abs(value) / tot * 100);
  // The 0.01 to 0.001 is a workaround for what appears to be a
  // CSS rendering bug on flat, transparent colors
  return (
    `linear-gradient(to right, rgba(0,0,0,0.01), rgba(0,0,0,0.001) ${perc1}%, ` +
    `rgba(${r},0,0,0.2) ${perc1}%, rgba(${r},0,0,0.2) ${perc1 + perc2}%, ` +
    `rgba(0,0,0,0.01) ${perc1 + perc2}%, rgba(0,0,0,0.001) 100%)`);

}

function SortIcon({ column }) {
  const { isSorted, isSortedDesc } = column;
  let sortIcon = ___EmotionJSX(FaSort, null);
  if (isSorted) {
    sortIcon = isSortedDesc ? ___EmotionJSX(FaSortDesc, null) : ___EmotionJSX(FaSortAsc, null);
  }
  return sortIcon;
}

function SearchInput({ count, value, onChange }) {
  return (
    ___EmotionJSX("span", { className: "dt-global-filter" },
    t('Search'), ' ',
    ___EmotionJSX("input", {
      className: "form-control input-sm",
      placeholder: tn('search.num_records', count),
      value: value,
      onChange: onChange })));



}

function SelectPageSize({
  options,
  current,
  onChange })
{
  return (
    ___EmotionJSX("span", { className: "dt-select-page-size form-inline" },
    t('page_size.show'), ' ',
    ___EmotionJSX("select", {
      className: "form-control input-sm",
      value: current,
      onBlur: () => {},
      onChange: (e) => {
        onChange(Number(e.target.value));
      } },

    options.map((option) => {
      const [size, text] = Array.isArray(option) ?
      option :
      [option, option];
      return (
        ___EmotionJSX("option", { key: size, value: size },
        text));


    })),
    ' ',
    t('page_size.entries')));


}var _ref = process.env.NODE_ENV === "production" ? { name: "8irbms", styles: "display:inline-flex;align-items:center" } : { name: "y1klox-getColumnConfigs", styles: "display:inline-flex;align-items:center;label:getColumnConfigs;", map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */", toString: _EMOTION_STRINGIFIED_CSS_ERROR__ };

export default function TableChart(
props)


{
  const {
    timeGrain,
    height,
    width,
    data,
    totals,
    isRawRecords,
    rowCount = 0,
    columns: columnsMeta,
    alignPositiveNegative: defaultAlignPN = false,
    colorPositiveNegative: defaultColorPN = false,
    includeSearch = false,
    pageSize = 0,
    serverPagination = false,
    serverPaginationData,
    setDataMask,
    showCellBars = true,
    emitFilter = false,
    sortDesc = false,
    filters,
    sticky = true, // whether to use sticky header
    columnColorFormatters } =
  props;
  const timestampFormatter = useCallback(
  (value) => getTimeFormatterForGranularity(timeGrain)(value),
  [timeGrain]);


  const handleChange = useCallback(
  (filters) => {
    if (!emitFilter) {
      return;
    }

    const groupBy = Object.keys(filters);
    const groupByValues = Object.values(filters);
    const labelElements = [];
    groupBy.forEach((col) => {
      const isTimestamp = col === DTTM_ALIAS;
      const filterValues = ensureIsArray(filters == null ? void 0 : filters[col]);
      if (filterValues.length) {
        const valueLabels = filterValues.map((value) =>
        isTimestamp ? timestampFormatter(value) : value);

        labelElements.push(`${valueLabels.join(', ')}`);
      }
    });
    setDataMask({
      extraFormData: {
        filters:
        groupBy.length === 0 ?
        [] :
        groupBy.map((col) => {
          const val = ensureIsArray(filters == null ? void 0 : filters[col]);
          if (!val.length)
          return {
            col,
            op: 'IS NULL' };

          return {
            col,
            op: 'IN',
            val: val.map((el) =>
            el instanceof Date ? el.getTime() : el),

            grain: col === DTTM_ALIAS ? timeGrain : undefined };

        }) },

      filterState: {
        label: labelElements.join(', '),
        value: groupByValues.length ? groupByValues : null,
        filters: filters && Object.keys(filters).length ? filters : null } });


  },
  [emitFilter, setDataMask]);


  // only take relevant page size options
  const pageSizeOptions = useMemo(() => {
    const getServerPagination = (n) => n <= rowCount;
    return PAGE_SIZE_OPTIONS.filter(([n]) =>
    serverPagination ? getServerPagination(n) : n <= 2 * data.length);

  }, [data.length, rowCount, serverPagination]);

  const getValueRange = useCallback(
  function getValueRange(key, alignPositiveNegative) {var _data$;
    if (typeof (data == null ? void 0 : (_data$ = data[0]) == null ? void 0 : _data$[key]) === 'number') {
      const nums = data.map((row) => row[key]);
      return (
        alignPositiveNegative ?
        [0, d3Max(nums.map(Math.abs))] :
        d3Extent(nums));

    }
    return null;
  },
  [data]);


  const isActiveFilterValue = useCallback(
  function isActiveFilterValue(key, val) {var _filters$key;
    return !!filters && ((_filters$key = filters[key]) == null ? void 0 : _filters$key.includes(val));
  },
  [filters]);


  function getEmitTarget(col) {var _meta$config;
    const meta = columnsMeta == null ? void 0 : columnsMeta.find((x) => x.key === col);
    return (meta == null ? void 0 : (_meta$config = meta.config) == null ? void 0 : _meta$config.emitTarget) || col;
  }

  const toggleFilter = useCallback(
  function toggleFilter(key, val) {
    let updatedFilters = { ...(filters || {}) };
    const target = getEmitTarget(key);
    if (filters && isActiveFilterValue(target, val)) {
      updatedFilters = {};
    } else {
      updatedFilters = {
        [target]: [val] };

    }
    if (
    Array.isArray(updatedFilters[target]) &&
    updatedFilters[target].length === 0)
    {
      delete updatedFilters[target];
    }
    handleChange(updatedFilters);
  },
  [filters, handleChange, isActiveFilterValue]);


  const getSharedStyle = (column) => {
    const { isNumeric, config = {} } = column;
    const textAlign = config.horizontalAlign ?
    config.horizontalAlign :
    isNumeric ?
    'right' :
    'left';
    return {
      textAlign };

  };

  const getColumnConfigs = useCallback(
  (column, i) => {
    const { key, label, isNumeric, dataType, isMetric, config = {} } = column;
    const isFilter = !isNumeric && emitFilter;
    const columnWidth = Number.isNaN(Number(config.columnWidth)) ?
    config.columnWidth :
    Number(config.columnWidth);

    // inline style for both th and td cell
    const sharedStyle = getSharedStyle(column);

    const alignPositiveNegative =
    config.alignPositiveNegative === undefined ?
    defaultAlignPN :
    config.alignPositiveNegative;
    const colorPositiveNegative =
    config.colorPositiveNegative === undefined ?
    defaultColorPN :
    config.colorPositiveNegative;

    const hasColumnColorFormatters =
    isNumeric &&
    Array.isArray(columnColorFormatters) &&
    columnColorFormatters.length > 0;

    const valueRange =
    !hasColumnColorFormatters && (
    config.showCellBars === undefined ?
    showCellBars :
    config.showCellBars) && (
    isMetric || isRawRecords) &&
    getValueRange(key, alignPositiveNegative);

    let className = '';
    if (isFilter) {
      className += ' dt-is-filter';
    }

    return {
      id: String(i), // to allow duplicate column keys
      // must use custom accessor to allow `.` in column names
      // typing is incorrect in current version of `@types/react-table`
      // so we ask TS not to check.
      accessor: (datum) => datum[key],
      Cell: ({ value }) => {
        const [isHtml, text] = formatColumnValue(column, value);
        const html = isHtml ? { __html: text } : undefined;

        let backgroundColor;
        if (hasColumnColorFormatters) {
          columnColorFormatters.
          filter((formatter) => formatter.column === column.key).
          forEach((formatter) => {
            const formatterResult = formatter.getColorFromValue(
            value);

            if (formatterResult) {
              backgroundColor = formatterResult;
            }
          });
        }

        const cellProps = {
          // show raw number in title in case of numeric values
          title: typeof value === 'number' ? String(value) : undefined,
          onClick:
          emitFilter && !valueRange ?
          () => toggleFilter(key, value) :
          undefined,
          className: [
          className,
          value == null ? 'dt-is-null' : '',
          isActiveFilterValue(key, value) ? ' dt-is-active-filter' : ''].
          join(' '),
          style: {
            ...sharedStyle,
            background:
            backgroundColor || (
            valueRange ?
            cellBar({
              value: value,
              valueRange,
              alignPositiveNegative,
              colorPositiveNegative }) :

            undefined) } };


        if (html) {
          // eslint-disable-next-line react/no-danger
          return ___EmotionJSX("td", _extends({}, cellProps, { dangerouslySetInnerHTML: html }));
        }
        // If cellProps renderes textContent already, then we don't have to
        // render `Cell`. This saves some time for large tables.
        return ___EmotionJSX("td", cellProps, text);
      },
      Header: ({ column: col, onClick, style }) =>
      ___EmotionJSX("th", {
        title: "Shift + Click to sort by multiple columns",
        className: [className, col.isSorted ? 'is-sorted' : ''].join(' '),
        style: {
          ...sharedStyle,
          ...style },

        onClick: onClick },


      config.columnWidth ?
      // column width hint
      ___EmotionJSX("div", {
        style: {
          width: columnWidth,
          height: 0.01 } }) :


      null,
      ___EmotionJSX("div", {
        css: _ref },




      ___EmotionJSX("span", null, label),
      ___EmotionJSX(SortIcon, { column: col }))),



      Footer: totals ?
      i === 0 ?
      ___EmotionJSX("th", null, t('Totals')) :

      ___EmotionJSX("td", { style: sharedStyle },
      ___EmotionJSX("strong", null, formatColumnValue(column, totals[key])[1])) :


      undefined,
      sortDescFirst: sortDesc,
      sortType: getSortTypeByDataType(dataType) };

  },
  [
  defaultAlignPN,
  defaultColorPN,
  emitFilter,
  getValueRange,
  isActiveFilterValue,
  isRawRecords,
  showCellBars,
  sortDesc,
  toggleFilter,
  totals,
  columnColorFormatters]);



  const columns = useMemo(
  () => columnsMeta.map(getColumnConfigs),
  [columnsMeta, getColumnConfigs]);


  const handleServerPaginationChange = (
  pageNumber,
  pageSize) =>
  {
    updateExternalFormData(setDataMask, pageNumber, pageSize);
  };

  return (
    ___EmotionJSX(Styles, null,
    ___EmotionJSX(DataTable, {
      columns: columns,
      data: data,
      rowCount: rowCount,
      tableClassName: "table table-striped table-condensed",
      pageSize: pageSize,
      serverPaginationData: serverPaginationData,
      pageSizeOptions: pageSizeOptions,
      width: width,
      height: height,
      serverPagination: serverPagination,
      onServerPaginationChange: handleServerPaginationChange
      // 9 page items in > 340px works well even for 100+ pages
      , maxPageItemCount: width > 340 ? 9 : 7,
      noResults: (filter) =>
      t(filter ? 'No matching records found' : 'No records found'),

      searchInput: includeSearch && SearchInput,
      selectPageSize: pageSize !== null && SelectPageSize
      // not in use in Superset, but needed for unit tests
      , sticky: sticky })));



}__signature__(TableChart, "useCallback{timestampFormatter}\nuseCallback{handleChange}\nuseMemo{pageSizeOptions}\nuseCallback{getValueRange}\nuseCallback{isActiveFilterValue}\nuseCallback{toggleFilter}\nuseCallback{getColumnConfigs}\nuseMemo{columns}");;(function () {var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;if (!reactHotLoader) {return;}reactHotLoader.register(getSortTypeByDataType, "getSortTypeByDataType", "/Users/ville/src/superset-release/superset-frontend/plugins/plugin-chart-table/src/TableChart.tsx");reactHotLoader.register(cellBar, "cellBar", "/Users/ville/src/superset-release/superset-frontend/plugins/plugin-chart-table/src/TableChart.tsx");reactHotLoader.register(SortIcon, "SortIcon", "/Users/ville/src/superset-release/superset-frontend/plugins/plugin-chart-table/src/TableChart.tsx");reactHotLoader.register(SearchInput, "SearchInput", "/Users/ville/src/superset-release/superset-frontend/plugins/plugin-chart-table/src/TableChart.tsx");reactHotLoader.register(SelectPageSize, "SelectPageSize", "/Users/ville/src/superset-release/superset-frontend/plugins/plugin-chart-table/src/TableChart.tsx");reactHotLoader.register(TableChart, "TableChart", "/Users/ville/src/superset-release/superset-frontend/plugins/plugin-chart-table/src/TableChart.tsx");})();;(function () {var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;leaveModule && leaveModule(module);})();